import React from 'react';
import PropTypes from 'prop-types';

import Img from '@src/components/Img';
import Modal from '@src/components/Modal';
import UIDotLine from '@src/components/UIDotLine';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const PackagesModal = (props) => {
	useStyles(css);
	const { title, params, previews, contentBlocks, onClose, FilesList } =
		props;

	return (
		<Modal size={600} title={title} position="right" onClose={onClose}>
			<div className={css.group}>
				<div className={css.wrap}>
					{Boolean(params.length) && (
						<div className={css.options}>
							{params.map(({ label, val }) => (
								<UIDotLine
									label={label}
									value={val}
									key={`${label}-${val}`}
								/>
							))}
						</div>
					)}
					{Boolean(contentBlocks.length) && (
						<div className={css.desc}>
							{contentBlocks.map((item) => (
								<div
									className={css.descItem}
									key={item.title || item.content}
								>
									{item.title && (
										<div className={css.descLabel}>
											{item.title}
										</div>
									)}
									<div
										// eslint-disable-next-line react/no-danger
										dangerouslySetInnerHTML={{
											__html: item.content,
										}}
									/>
								</div>
							))}
						</div>
					)}
				</div>

				{FilesList && <FilesList />}

				{Boolean(previews.length) && (
					<div className="prfl-mdl-preview">
						{previews.map((img) => (
							<Img
								{...img}
								width={260}
								height={170}
								key={img.src}
							/>
						))}
					</div>
				)}
			</div>
		</Modal>
	);
};

PackagesModal.propTypes = {
	title: PropTypes.string,
	previews: PropTypes.arrayOf(PropTypes.shape({ ...Img.type.propTypes })),
	params: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			val: PropTypes.string,
		}),
	),
	contentBlocks: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			content: PropTypes.string,
		}),
	),
	FilesList: PropTypes.elementType,
	onClose: PropTypes.func,
};

PackagesModal.defaultProps = {
	title: undefined,
	FilesList: undefined,
	params: [],
	previews: [],
	contentBlocks: [],
	onClose: undefined,
};

export default PackagesModal;
